import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';

const Students = () => {
  const [assignments, setAssignments] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/assignments`)
      .then(res => res.json())
      .then(data => setAssignments(data))
      .catch(err => console.error('Error fetching assignments:', err));
  }, []);

  return (
    <div className="students">
      <h2>Student Assignments for Today</h2>
      <ul className="assignment-list">
        {assignments.map((task, index) => (
          <li key={task.id || index}>{task.task}</li>
        ))}
      </ul>
    </div>
  );
};

export default Students;